import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('collaboration-sidebar-common', {
  library: 'collaboration-sidebar-common'
});